<div class="page-center">
	<div class="text-center">
		<h1>404</h1>
		<div>Page not found</div>
	</div>
</div>
